import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { RentPrepaymentFilter } from '../../../../models/Filter';
import { PrePaymentButtonFilterView } from '../../desktop/pre_payment/PrePaymentButtonFilterView';

interface IPrePaymentFilter {
    filter: RentPrepaymentFilter;
    handleChange: (filter: RentPrepaymentFilter) => void;
    classNameGroup?: string;
}

export const MobilePrePaymentFilterButtonView: React.FC<IPrePaymentFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Предоплата'>
            <PrePaymentButtonFilterView
                filter={filter}
                handleChange={handleChange}
                classNameGroup={classNameGroup}
            />
        </MobileFilter2>
    );
};
